import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63110d1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "name", "value", "checked"]
const _hoisted_2 = ["for", "title"]
const _hoisted_3 = { class: "sr-only" }
const _hoisted_4 = ["src", "alt"]

import { computed } from 'vue';
import { isReadable } from '@ctrl/tinycolor';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomizerMiniRadioSwatch',
  props: {
    id: null,
    name: null,
    label: { default: undefined },
    imgUrl: { default: undefined },
    hexCode: { default: 'transparent' },
    value: null,
    checked: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { id: string, name: string, label: string, imgUrl: string, hexCode: string, value: string, checked: boolean }



const contrastIsInsufficient = computed<boolean>(() => {
    return !!props.hexCode && !isReadable('#ffffff', props.hexCode);
});


return (_ctx: any,_cache: any) => {
  const _directive_on_error = _resolveDirective("on-error")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", _mergeProps({ id: __props.id }, { ..._ctx.$attrs }, {
      type: "radio",
      name: __props.name,
      value: __props.value,
      checked: __props.checked
    }), null, 16, _hoisted_1),
    _createElementVNode("label", {
      for: __props.id,
      class: "block overflow-hidden w-26 h-26 rounded-full p-2 cursor-pointer",
      title: __props.label
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.label), 1),
      _createElementVNode("span", {
        class: "relative block h-full w-full rounded-full overflow-hidden",
        style: _normalizeStyle({'background-color': __props.hexCode})
      }, [
        (__props.imgUrl)
          ? _withDirectives((_openBlock(), _createElementBlock("img", {
              key: 0,
              width: "200",
              height: "160",
              src: __props.imgUrl,
              alt: __props.label,
              class: "min-w-200 min-h-160 xy-center"
            }, null, 8, _hoisted_4)), [
              [_directive_on_error, 'c-on-error--material']
            ])
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: _normalizeClass(["h-full rounded-full w-full xy-center", {'color-contrast-handler': _unref(contrastIsInsufficient)}]),
          "aria-hidden": "true"
        }, null, 2)
      ], 4)
    ], 8, _hoisted_2)
  ]))
}
}

})